




























import Vue from 'vue';
import Logo from '@/components/common/Logo.vue';
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue';
import TopNavigation from '@/components/common/TopNavigation.vue';
import BurgerIcon from '../assets/img/hamburger-slim.svg';
import CloseIcon from '../assets/img/close.svg';
export default Vue.extend({
    name: 'Header',
    components: { TopNavigation, LanguageSwitcher, Logo, BurgerIcon, CloseIcon },
    data: function() {
        return {
            isMobileMenuVisible: false,
            clientWidth: 0,
        };
    },
    computed: {
        isMenuDisplayed(): boolean {
            return !this.isMobile || this.isMobileMenuVisible;
        },
        isMobile(): boolean {
            return this.clientWidth < 768;
        },
    },
    created() {
        window.addEventListener('resize', this.updateClientWidth);
        this.updateClientWidth();
    },
    destroyed() {
        window.removeEventListener('resize', this.updateClientWidth);
    },
    methods: {
        toggleMobileMenu() {
            this.isMobileMenuVisible = !this.isMobileMenuVisible;
        },
        updateClientWidth() {
            this.clientWidth = window.innerWidth;
        },
    },
});
